//JS LIBRARIES
global.Modal = require('bootstrap/js/dist/modal');
global.Collapse = require('bootstrap/js/dist/collapse');
global.Offcanvas = require('bootstrap/js/dist/offcanvas');
global.Carousel = require('bootstrap/js/dist/carousel');
const LazyLoad = require("vanilla-lazyload");
global.lazyLoad = new LazyLoad();
require('../../scripts-optimized/lazy-loading-polyfill');
require('../../scripts/Tools/webp-polyfill');
require('../../scripts-optimized/polyfills');
require('../../scripts-optimized/core-web-vitals');

//JS
require('../../scripts-optimized/Whatsapp/main-critic');
require('../../scripts-optimized/MessageSOS/main-critic');
require('../../scripts-optimized/HelpWidget/main-critic');
require('../../scripts-optimized/Cookies/main-critic');
require('../../scripts-optimized/Newsletter/main-critic');
require('../../scripts-optimized/Country/Popup/main-critic');
require('../../scripts-optimized/PopupSmarterClick/main-critic');
require('../../scripts-optimized/Header/Messages/main-critic');
require('../../scripts-optimized/Header/Searcher/main-critic');
require('../../scripts-optimized/Header/Login/main-critic');
require('../../scripts-optimized/Header/Cart/main-critic');
require('../../scripts-optimized/Cart/General/main-critic');
require('../../scripts-optimized/Cart/Item/General/main-critic');
require('../../scripts-optimized/Cart/Item/Options/Size/main-critic');
require('../../scripts-optimized/Cart/Item/Options/GlassReversed/main-critic');
require('../../scripts-optimized/Cart/Item/Options/Pack/main-critic');
require('../../scripts-optimized/Cart/Item/Options/Color/main-critic');
require('../../scripts-optimized/Cart/Item/Options/CustomText/main-critic');
require('../../scripts-optimized/Cart/Item/Options/CustomImage/main-critic');
require('../../scripts-optimized/Cart/Item/Options/Tissue/main-critic');
require('../../scripts-optimized/Cart/Item/Options/TissueDrop/main-critic');
require('../../scripts-optimized/Cart/Item/Options/SupportColor/main-critic');
require('../../scripts-optimized/Cart/Item/Options/Model/main-critic');
require('../../scripts-optimized/Cart/Item/Options/MaterialColor/main-critic');
require('../../scripts-optimized/Cart/Item/Options/ModelSize/main-critic');
require('../../scripts-optimized/Cart/Item/ImageZoom/main-critic');
require('../../scripts-optimized/Cart/Voucher/main-critic');
require('../../scripts-optimized/Header/OuterMenu/main-critic');
require('../../scripts-optimized/Header/Breadcrumb/main-critic');
require('../../scripts-optimized/LeftMenu/main-critic');
require('../../scripts-optimized/LeftMenuV2/main-critic');
require('../../scripts-optimized/Product/Size/main-critic');
require('../../scripts-optimized/Product/Color/main-critic');
require('../../scripts-optimized/Product/Pack/main-critic');
require('../../scripts-optimized/Product/CustomText/main-critic');
require('../../scripts-optimized/Product/CustomImage/main-critic');
require('../../scripts-optimized/Product/GlassReversed/main-critic');
require('../../scripts-optimized/Product/Tissue/main-critic');
require('../../scripts-optimized/Product/TissueDrop/main-critic');
require('../../scripts-optimized/Product/ChainPosition/main-critic');
require('../../scripts-optimized/Product/SupportColor/main-critic');
require('../../scripts-optimized/Product/ModelGender/main-critic');
require('../../scripts-optimized/Product/Model/main-critic');
require('../../scripts-optimized/Product/ModelSize/main-critic');
require('../../scripts-optimized/Product/MaterialColor/main-critic');
require('../../scripts-optimized/Product/Complement/main-critic');
require('../../scripts-optimized/Tools/Textarea/main-critic');
require('../../scripts-optimized/Tools/ScrollTopButton/main-critic');
require('../../scripts-optimized/Tools/PopupImageZoom/main-critic');


require('../../scripts-optimized/ProductPage/General/main-critic');
require('../../scripts-optimized/ProductPage/Reviews/main-critic');
require('../../scripts-optimized/ProductPage/Options/Size/MultipleSelectable/main-critic');
require('../../scripts-optimized/ProductPage/Options/CustomText/Selectable/main-critic');
require('../../scripts-optimized/ProductPage/Options/CustomImage/Selectable/main-critic');
require('../../scripts-optimized/ProductPage/PopupPersonalizedText/main-critic');
require('../../scripts-optimized/ProductPage/Quantity/main-critic');
require('../../scripts-optimized/ProductPage/ImageZoom/main-critic');
require('../../scripts-optimized/ProductPage/ArTool/main-critic');
require('../../scripts-optimized/PopupPersonalizedText/main-critic');


require('../../scripts-optimized/Footer/Contact/main-critic');
require('../../scripts-optimized/Footer/Newsletter/main-critic');
require('../../scripts-optimized/Footer/Social/main-critic');